var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m666-305-43-43 102-102H375v-60h348L621-612l43-43 176 176-174 174ZM120-120v-720h351v60H180v600h291v60H120Z"
  })));
};
export default SvgLogout;